import { Button, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { moveItem } from "components/dragReorder";
import { CheckListRow, ReorderableCheckList } from "components/ReorderableCheckList";
import { useState, useEffect } from "react";

export interface ActivityFilter {
    id: string
    order: number
    name: string
    user: string
    query: string
    tableDensity: string
    pageCount: number
    enabled: number
    fields: ActivityFilterField[]
}

export interface ActivityFilterField {
    columnId: string
    width: string
}

export interface FilterSelectorProps {
    filters: ActivityFilter[]
    onSave: (a: ActivityFilter[]) => void
}

// NS-731: list, drag-reorder and ghost now come from ReorderableCheckList.
export function FilterSelector(props: FilterSelectorProps) {
    const [open, setOpen] = useState(false);
    const [filtersState, setFiltersState] = useState<ActivityFilter[]>(props.filters);

    useEffect(() => {
        setFiltersState(props.filters);
    }, [props.filters]);


    const clicked = () => {
        if (!open) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    };

    const cancel = () => {
        setFiltersState(props.filters);
        setOpen(false);
    };

    const save = () => {
        filtersState.forEach((x, i) => {
            x.order = i;
        });

        props.onSave(filtersState);
        setOpen(false);
    };

    const visibleFilters = filtersState.filter(x => x);

    return <ReorderableCheckList
        buttonLabel="Manage Filters"
        open={open}
        onButtonClick={clicked}
        onClose={() => setOpen(false)}
        header={<>
            <Typography>Filter Settings</Typography>
            <CheckListRow
                key={"main"}
                label={"Main"}
                checked={true}
                disabled={true} />
        </>}
        items={visibleFilters.map(x => ({
            label: x?.name,
            checked: Boolean(x?.enabled),
            disabled: false,
        }))}
        onToggle={(idx) => {
            const toggled = visibleFilters[idx];
            setFiltersState(filtersState.map(y => {
                if (y.id === toggled.id) {
                    return {
                        ...y,
                        enabled: !y.enabled ? 1 : 0,
                    };
                }
                return y;
            }));
        }}
        onReorder={(from, to) => {
            const newFilters = filtersState.map(x => {
                return { ...x } as ActivityFilter;
            });//do a deep copy of the state array

            moveItem(newFilters, from, to);
            setFiltersState(newFilters);
        }}
        footer={
            <Stack sx={{ marginTop: "10px" }} direction="row">
                <Button sx={{ marginLeft: "5px" }} variant="outlined" onClick={cancel}>Cancel</Button>
                <Button sx={{ marginLeft: "5px" }} variant="contained" onClick={save}>Apply</Button>
            </Stack>
        }
    />;
}
